import { deleteActualStop } from '@/api/jobs'
import { useMutation, useQueryClient } from '@tanstack/vue-query'

export function useDeleteActualStopMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ jobId, stopId }: { jobId: string; stopId: string }) => {
      return deleteActualStop(jobId, stopId)
    },
    onSuccess: async (_, variables) => {
      await Promise.all([
        queryClient.invalidateQueries(['stops', 'byJobId', variables.jobId]),
        queryClient.invalidateQueries(['requested-stops', 'byJobId', variables.jobId]),
        queryClient.invalidateQueries(['stops', 'byId', variables.stopId]),
      ])
    },
  })
}
